import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { ArrowSquareOut } from '@liveauctioneers/hammer-ui-core/icons';
import { WebRTCPlayer } from '@liveauctioneers/hammer-ui-core/webRTCPlayer';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useStreamIdPolling } from '@/hooks/useStreamIdPolling';
import { useAppSelector } from '@/redux/hooks';
import { getAntMediaHostname } from '@/redux/modules/config';

const PLACEHOLDER_URL = 'https://p1.liveauctioneers.com/dist/images/auction16x9.jpg?quality=50';

type Props = {
    catalogId: number;
    className?: string;
    onOpenInNewWindow?: () => void;
};

/**
 * Video player for auction livestream
 */
const AuctionVideoStream = ({ catalogId, className, onOpenInNewWindow }: Props) => {
    const streamId = useStreamIdPolling(catalogId);
    const antMediaHostname = useAppSelector(getAntMediaHostname);

    return (
        <div className={cn('relative w-full !pt-[56.25%]', className)}>
            <WebRTCPlayer
                className="absolute inset-0"
                hostname={antMediaHostname}
                placeholderUrl={PLACEHOLDER_URL}
                streamId={streamId}
            />
            {onOpenInNewWindow && (
                <IconButton
                    aria-label="Open video in new window"
                    className="absolute right-xs top-xs z-[2]"
                    icon={ArrowSquareOut}
                    onClick={onOpenInNewWindow}
                    shape="square"
                    size="sm"
                    style="inverse"
                    variant="transparent"
                />
            )}
        </div>
    );
};

export default AuctionVideoStream;
